import { Box, Chip, Paper, Stack, Tooltip, Typography } from "@mui/material";
import ShoppingBasketIcon from "@mui/icons-material/ShoppingBasket";
import { OrderType } from "../../../interfaces/delivery-company/orders";
import React from "react";

interface SelectionBasketProps {
  selectedOrders: Map<string, OrderType>;
}

/**
 * Small, compact "Selection Basket" that shows how many orders are selected.
 * This is the *drag source* for assigning to tasks.
 */
export const SelectionBasket: React.FC<SelectionBasketProps> = ({
  selectedOrders,
}) => {
  const selectedCount = selectedOrders.size;

  const handleDragStart = (e: React.DragEvent<HTMLDivElement>) => {
    if (!selectedCount) {
      e.preventDefault();
      return;
    }
    // Required so the drag is considered valid.
    e.dataTransfer.setData("application/x-internal-transfer", "selection");
    e.dataTransfer.effectAllowed = "move";
  };

  const handleDragEnd = () => {
    // nothing special for now
  };

  return (
    <Tooltip
      title={
        selectedCount
          ? "Drag this basket onto a task card to assign the selected orders."
          : "Select orders in the table to use the basket."
      }
      placement="top"
    >
      <Paper
        elevation={selectedCount ? 3 : 1}
        sx={{
          p: 1.5,
          borderRadius: 2,
          display: "inline-flex",
          alignItems: "center",
          gap: 1,
          borderStyle: "solid",
          borderWidth: 1,
          borderColor: selectedCount ? "primary.main" : "divider",
          opacity: selectedCount ? 1 : 0.6,
          cursor: selectedCount ? "grab" : "default",
          userSelect: "none",
          maxWidth: "100%",
        }}
        draggable={!!selectedCount}
        onDragStart={handleDragStart}
        onDragEnd={handleDragEnd}
      >
        <ShoppingBasketIcon fontSize="small" />
        <Box sx={{ minWidth: 0 }}>
          <Typography variant="subtitle2" noWrap>
            Selection Basket
          </Typography>
          <Typography variant="caption" color="text.secondary" noWrap>
            {selectedCount
              ? "Drag onto a task to assign"
              : "No orders selected"}
          </Typography>
        </Box>
        <Stack direction="row" sx={{ ml: "auto" }}>
          <Chip
            size="small"
            color={selectedCount ? "primary" : "default"}
            label={`${selectedCount}`}
          />
        </Stack>
      </Paper>
    </Tooltip>
  );
};
